// src/routes/HomeRedirect.tsx

import { Navigate } from 'react-router-dom';
import { useUserCustomersStore } from '@/domains/user/userCustomers.store';
import { useUserProfileStore } from '@/domains/user/userProfile.store';
import { useRouteAccess } from '@/shared/hooks/useRouteAccess';

const HomeRedirect: React.FC = () => {
  const user = useUserProfileStore((s) => s.user);
  const customer = useUserCustomersStore((s) => s.selectedCustomer);

  const { landingPath } = useRouteAccess(user, customer);
  return <Navigate to={landingPath} replace />;
};

export default HomeRedirect;
